import React, { useState } from 'react';
import { option } from 'geniebook-ui/dist/components/DropdownFilter/selection';
import CaretDown from '@assets/icons/caret-down';
import { Radio } from 'geniebook-ui/dist';

export interface SortingMobileProps<value> {
  options: option<value>[];
  selected: value;
  setSelection: (value: value) => void;
}

const SortingMobile = (props: SortingMobileProps<string | number>) => {
  const [openSelection, setOpenSelection] = useState(true);

  return (
    <div className={'mb-6'}>
      <div
        className={openSelection ? 'mb-4' : ''}
        onClick={() => setOpenSelection(!openSelection)}
        data-testid={'show-button'}
      >
        <span className={'leading-4 text-neutral-chalk font-bold'}>
          Sort By{!openSelection ? ': ' : ''}
        </span>
        {!openSelection ? (
          <span
            className={'leading-4 text-neutral-chalk font-regular'}
            data-testid={'selected'}
          >
            {
              props.options.filter(item => item.value === props.selected)[0]
                .label
            }
          </span>
        ) : null}
        <CaretDown
          className={
            'fill-current text-primary-apricot ml-2 align-text-top w-2.5 inline-block transition-all ' +
            (openSelection ? 'rotate-180' : '')
          }
        />
      </div>
      <div
        className={'transition-all overflow-hidden'}
        style={{ height: openSelection ? 'auto' : 0 }}
      >
        {props.options.map(item => {
          return (
            <Radio
              isChecked={item.value === props.selected}
              isValidation={false}
              variant={'dark'}
              label={item.label}
              className={'mb-3.5 last-of-type:mb-0'}
              value={item.value}
              onChange={event => {
                props.setSelection(event.target.value);
                setOpenSelection(false);
              }}
              key={item.value}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SortingMobile;
